<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <defs>
  </defs>
  <g>
    <path class="cls-3" d="m70.24,42.58h-13.43c-1.14,0-2.05.92-2.05,2.06v13.43c0,1.14.92,2.05,2.05,2.05h13.43c1.14,0,2.06-.92,2.06-2.05v-13.43c0-1.14-.92-2.06-2.06-2.06Zm-4.11,3.66c-.19.19-.45.31-.74.31h-3.74c-.58,0-1.05-.46-1.05-1.04,0-.29.12-.55.31-.74.19-.19.45-.31.74-.31h3.74c.57,0,1.04.47,1.04,1.05,0,.29-.12.55-.31.74Z"/>
    <path class="cls-3" d="m60.49,61.16h-13.43c-1.14,0-2.05.92-2.05,2.06v13.43c0,1.14.92,2.05,2.05,2.05h13.43c1.14,0,2.06-.92,2.06-2.05v-13.43c0-1.14-.92-2.06-2.06-2.06Zm-4.11,3.66c-.19.19-.45.31-.74.31h-3.74c-.58,0-1.05-.46-1.05-1.04,0-.29.12-.55.31-.74.19-.19.45-.31.74-.31h3.74c.57,0,1.04.47,1.04,1.05,0,.29-.12.55-.31.74Z"/>
    <path class="cls-3" d="m79.98,61.16h-13.43c-1.14,0-2.05.92-2.05,2.06v13.43c0,1.14.92,2.05,2.05,2.05h13.43c1.14,0,2.06-.92,2.06-2.05v-13.43c0-1.14-.92-2.06-2.06-2.06Zm-4.11,3.66c-.19.19-.45.31-.74.31h-3.74c-.58,0-1.05-.46-1.05-1.04,0-.29.12-.55.31-.74.19-.19.45-.31.74-.31h3.74c.57,0,1.04.47,1.04,1.05,0,.29-.12.55-.31.74Z"/>
  </g>
  <g>
    <path class="cls-1" d="m35.68,17.99v22.08c0,1.42-1.16,2.58-2.58,2.58h-15.3c-1.42,0-2.58-1.16-2.58-2.58v-22.08h20.46m1.23-3H14.56c-1.29,0-2.34,1.05-2.34,2.34v22.74c0,3.08,2.5,5.58,5.58,5.58h15.3c3.08,0,5.58-2.5,5.58-5.58v-23.31c0-.98-.79-1.77-1.77-1.77h0Z"/>
    <g>
      <g>
        <path class="cls-3" d="m31.9,15.15c-.48,0-.86-.39-.86-.86,0-3.08-2.51-5.58-5.58-5.58s-5.59,2.51-5.59,5.58c0,.48-.39.86-.86.86s-.86-.39-.86-.86c0-4.03,3.28-7.31,7.32-7.31s7.31,3.28,7.31,7.31c0,.48-.39.86-.86.86Z"/>
        <path class="cls-3" d="m19,20.53c-.48,0-.86-.39-.86-.86v-5.38c0-.48.39-.86.86-.86s.86.39.86.86v5.38c0,.48-.39.86-.86.86Z"/>
      </g>
      <path class="cls-3" d="m31.9,20.53c-.48,0-.86-.39-.86-.86v-5.38c0-.48.39-.86.86-.86s.86.39.86.86v5.38c0,.48-.39.86-.86.86Z"/>
    </g>
    <g>
      <path class="cls-3" d="m32.99,29.68h-15.08c-.36,0-.65-.29-.65-.65s.29-.65.65-.65h15.08c.36,0,.65.29.65.65s-.29.65-.65.65Z"/>
      <path class="cls-3" d="m30.72,33.76h-10.55c-.36,0-.65-.29-.65-.65s.29-.65.65-.65h10.55c.36,0,.65.29.65.65s-.29.65-.65.65Z"/>
    </g>
  </g>
  <line class="cls-2" x1="73.79" y1="16.21" x2="16.21" y2="73.79"/>
</svg>
</template>

<script>
export default {
    name: "BaggedVsBulkDashboardIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #115c72;
  }
  .cls-2 {
    fill: none;
    stroke: #cfeae0;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 4px;
  }
  .cls-3 {
    fill: #59c5c7;
  }
</style>